export default function useTiersHook(tierName) {
    const tiers = {
        Free: {
            name: 'Free',
            desc: 'For those dipping their toe into email marketing with up to 250 contacts and 1 user.',
            features: [
                { name: 'Feature 1', help: 'Help text for feature 1' },
                { name: 'Feature 2', help: 'Help text for feature 2' }
            ]
        },
        Starter: {
            name: 'Starter',
            desc: "Perfect if you're just starting out with marketing and want to take things one step at a time.",
            features: [
                { name: 'Up to 3 users', help: '' },
                {
                    name: 'Create engaging copy using AI Content Assistant',
                    help: "Transpond's AI Content Assistant enables you to quickly generate engaging email copy with a single prompt."
                },
                {
                    name: 'Optimised email sending',
                    help: 'Automatically manages campaign sends to ensure maximum deliverability to your subscribers inboxes'
                },
                {
                    name: 'Schedule social posts in advance',
                    help: 'Rapidly grow your brand by creating, scheduling, and analyzing entire social media campaigns.'
                },
                {
                    name: 'Enable live chat on your website',
                    help: 'Connect visitors with the right team instantly. Perfect for support, sales, and leads.'
                }
            ]
        },
        Growth: {
            name: 'Growth',
            desc: 'Ideal for companies looking to scale marketing activity across different channels.',
            features: [
                { name: 'Up to 5 users', help: '' },
                {
                    name: 'Engagement-based email sending',
                    help: 'Automatically sends emails based on when your audience is most likely to engage with your campaigns'
                },
                { name: 'A/B test your campaigns', help: '' },
                { name: 'Manage multiple social accounts', help: '' },
                { name: 'Create unlimited Automations', help: '' }
            ]
        },
        Advanced: {
            name: 'Advanced',
            desc: 'Ideal for experienced marketers looking for an affordable all-in-one marketing tool.',
            features: [
                { name: '10 Users', help: '' },
                { name: 'Inbox AI Assistant', help: '' }
            ]
        },
        Ultimate: {
            name: 'Ultimate',
            desc: 'For established marketing teams looking for a solution that slots neatly into their existing marketing strategy.',
            features: [
                { name: 'Feature 3', help: 'Help text for feature 3' },
                { name: 'Feature 4', help: 'Help text for feature 4' }
            ]
        }
    }

    return tiers[tierName] || null
}
